<template>
  <div>
    <div
      v-if="!loading"
      v-cloak
      @drop.prevent="addFile"
      @dragover.prevent
      @dragover="forceBrowserCopy($event)"
      class="drop-wrapper"
    >
      <div class="dropzone">
        <input
          v-if="!uploading"
          type="file"
          id="file"
          ref="file"
          :class="disabled ? 'input-file-disabled' : 'input-file'"
          multiple="multiple"
          v-on:change="handleFileInput"
          :disabled="uploading || disabled"
        />
        <p v-if="!uploading">
          Drag and drop a file or <br />
          click here to add attachments
        </p>
        <div v-if="uploading" class="full-screen">
          <v-progress-circular v-if="uploading" indeterminate color="primaryStart" :width="3" />
        </div>
      </div>
      <!-- <v-tooltip left>
        <template v-slot:activator="{ on }">
          <div class="dropzone" v-on="on">
            <input
              type="file"
              id="file"
              ref="file"
              class="input-file"
              multiple="multiple"
              v-on:change="handleFileInput"
            />
            <p>
              Drag and drop files or <br />
              click here to add attachments
            </p>
          </div>
        </template>
        <div>
          Max 5 files of max 20MB each allowed
          <br />
          Files with the following characters are not supported,
          <br />
          rename these file(s) beforehand: &#x22;*:&#x3C;&#x3E;?/\|#%
        </div>
      </v-tooltip> -->
    </div>
  </div>
</template>

<script>
import config from '@/config'
// import helpers from '@/plugins/helpers'
import { mapActions, mapGetters } from 'vuex'
export default {
  props: {
    disabled: {
      type: Boolean,
      defaul: false
    }
  },
  data: () => ({
    uploadFiles: [],
    uploadDone: true,
    uploading: false
  }),
  computed: {
    ...mapGetters({
      user: 'general/user'
    }),
    loading: {
      get() {
        return false
      },
      set(value) {
        this.$emit('update:loading', value)
      }
    }
  },
  mounted() {},
  methods: {
    ...mapActions({
      setSnackbar: 'general/setSnackbar'
    }),
    forceBrowserCopy: evt => {
      evt.dataTransfer.dropEffect = 'copy'
      evt.dataTransfer.effectAllowed = 'copy'
    },
    addFile(e) {
      let ok = true
      this.uploadFiles = []
      let droppedFiles = e.dataTransfer.files
      if (!droppedFiles) return
      ;[...droppedFiles].forEach(f => {
        if (f.size / 1048576 > 20) {
          this.setSnackbar({ msg: '1 or more files are larger than 20MB', status: 'error' })
          this.uploadFiles = []
          ok = false
          return
        }
        this.uploadFiles.push(f)
      })
      if (ok) this.setUploadFiles()
    },
    handleFileInput(e) {
      let ok = true
      this.uploadFiles = []
      ;[...e.srcElement.files].forEach(f => {
        if (f.size / 1048576 > 20) {
          this.setSnackbar({ msg: '1 or more files are larger than 20MB', status: 'error' })
          this.uploadFiles = []
          this.$refs.file.value = ''
          ok = false
          return
        }
        this.uploadFiles.push(f)
      })
      this.$refs.file.value = ''
      if (ok) this.setUploadFiles()
    },
    async setUploadFiles() {
      this.uploading = true
      for (let i = 0; i < this.uploadFiles.length; i++) {
        let formData = new FormData()
        let file = this.uploadFiles[i]
        formData.append('file', file)
        // await helpers.fetchApi(config.apiUrl + `attachment/${this.bidformid}`, 'post', formData)

        await this.$axios
          .post(config.apiUrl + `customer-questionnaire/${this.$route.params.id}/attachment`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(() => {})
          .catch(err => {
            this.setSnackbar({
              msg: 'This file type is not supported, please hover the info icon for more information',
              status: 'error'
            })
            console.log(err)
          })
      }
      this.$emit('uploaddone')
      this.uploading = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/_variables.scss';
.sharepoint-wrapper {
  margin: 1rem;
}

.dropzone {
  position: relative;
  z-index: 0;
  padding: 0.5rem;
  height: 70px;
  border: 1px dashed $background-2; // border-style: dashed;
  display: flex;
  justify-content: center;
  align-items: center;
  p {
    text-align: center;
    font-size: 1rem;
    color: $background-2;
    margin: 0;
    padding: 0;
  }
}

.input-file {
  opacity: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  cursor: pointer;
  z-index: 9;
  margin: -7px;
}
.input-file-disabled {
  opacity: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 9;
  margin: -7px;
}
</style>
